<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="card"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="次数限定">
        <el-switch v-model="card.is_number_limit" :active-value="1" :inactive-value="0"/>
      </el-form-item>
      <el-form-item
        label="有效次数"
        prop="expire_number"
        v-if="card.is_number_limit"
      >
        <v-input-money
          class="w100"
          placeholder="每次预约课程后有效次数将递减，为 0 时不可继续使用"
          v-model="card.expire_number"
        />
      </el-form-item>
      <el-form-item label="所补差价" prop="actual_payment">
        <v-input-money
          class="w100"
          v-model="card.update_payment"
          :is-show-suffix="true"
          placeholder="请输入此次修改所补的差价，退款填写为负数即可"
          type="int"
        />
      </el-form-item>
      <el-form-item v-if="+card.update_payment !== 0" label="补差价方式" prop="update_payment_mode">
        <v-select-card-payment-mode class="w100" v-model="card.update_payment_mode"/>
      </el-form-item>
      <el-form-item v-if="!isAdministrator" label="修改原因" prop="update_remark">
        <el-input
          v-model="card.update_remark"
          placeholder="请输入修改课卡的原因"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item>
        <router-link v-if="card.card_del_apply_id" class="button-margin" :to="RouteConfig.cardDeleteApplyDetail.to(card.card_del_apply_id)">
          <el-button type="primary">退卡申请审核中，点击查看</el-button>
        </router-link>
        <router-link v-else-if="card.card_update_apply_id" class="button-margin" :to="RouteConfig.cardUpdateApplyDetail.to(card.card_update_apply_id)">
          <el-button type="primary">课卡修改审核中，点击查看</el-button>
        </router-link>
        <el-button v-else-if="card.is_reviewing" class="button-margin" :disabled="true" type="primary">修改申请审核中</el-button>
        <el-button v-else class="button-margin" :loading="isSaving" type="primary" @click="handleSubmit">
          {{ isAdministrator ? '保存' : '申请'}}修改
        </el-button>
        <el-button @click="RouteConfig.cardList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { mapGetters } from 'vuex';
  import { show, updateNumber } from '@/api/card';
  import { storeNumber } from '@/api/card-update-apply';
  import { toCent, toYuan } from '@/utils/number';
  import cardPaymentModeIds from "@/enums/cardPaymentModeIds";

  export default {
    name: RouteConfig.cardEditNumber.name,
    data: () => ({
      RouteConfig,
      isSearching: false,
      isSaving: false,
      keyword: '',
      checked_class_types: [],
      class_charge_types: [],
      stores: [],
      students: [],
      cardPaymentModes: [],
      card: {
        is_number_limit: true,
        expire_number: 0,
        update_payment: '',
        update_remark: '',
        is_reviewing: 0,
        card_del_apply_id: 0,
        card_update_apply_id: 0,
        update_payment_mode: 0,
      },
      rules: {
        update_remark: [{required: true, message: '请输入修改课卡的原因', trigger: 'change'}],
        update_payment_mode: [{ required: true, message: '请选择补差价付款方式', trigger: 'change' }],
      },
      pickerOptions: {
        disabledDate: (time) => time.getTime() < 0,
      },
      cardPaymentModeIds,
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
      ]),
      id() {
        return +this.$route.params.id || 0;
      },
    },
    methods: {
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          const card = {...this.card};
          if (card.is_number_limit) {
            card.expire_number = toCent(card.expire_number);
          } else {
            card.expire_number = 0;
          }
          card.card_id = this.id;
          card.update_payment = toCent(card.update_payment);

          this.isSaving = true;
          const { isError } = this.isAdministrator
            ? await updateNumber(this.id, card)
            : await storeNumber(card);
          this.isSaving = false;

          if (!isError) this.isAdministrator ? RouteConfig.cardList.back() : RouteConfig.cardUpdateApplyList.push();

        });
      },
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        Object.assign(this.card, {
          expire_number: toYuan(data.expire_number),
          is_number_limit: data.is_number_limit ? 1 : 0,
          is_reviewing: data.is_reviewing ? 1 : 0,
          card_del_apply_id: data.card_del_apply_id || 0,
          card_update_apply_id: data.card_update_apply_id || 0,
        });
      },
    },
    beforeMount() {
      this.show();
    },
  };
</script>
